// extracted by css-extract-rspack-plugin
export default {"paged":"V_78l2","start-infscroll-button":"f891gO","startInfscrollButton":"f891gO","hidden":"Man4yu"};